import { AgGridReact } from '@mint-lib/ag-grid/react';
import { useMemo } from 'react';

import { type ColDef } from '@mint-lib/ag-grid/community';
import { LoadingCell } from '@mint-lib/ag-grid/components';
import { useTranslation } from '@mint-lib/i18n';

const rowData = Array.from({ length: 20 }).map(() => ({
  value: null,
}));

export const GlossaryTableSkeleton = () => {
  const { t } = useTranslation('@myn/import-hub');

  const defaultColDef: ColDef = useMemo(
    () => ({
      cellRenderer: LoadingCell,
      flex: 1,
      sortable: false,
      suppressHeaderMenuButton: true,
    }),
    [],
  );

  const columnDefs = useMemo<ColDef[]>(
    () => [
      {
        field: 'item',
        headerName: t('Item'),
      },
      {
        field: 'alias',
        headerName: t('Alias'),
      },
    ],
    [t],
  );

  return (
    <AgGridReact
      domLayout="autoHeight"
      columnDefs={columnDefs}
      defaultColDef={defaultColDef}
      rowData={rowData}
      suppressNoRowsOverlay
    />
  );
};
